import request from './request';

function toFormData(payload, file) {
  const form = new FormData();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    form.append(key, value);
  });
  if (file) {
    form.append('image', file);
  }
  return form;
}

const settingsFaqsService = {
  getAll: (params) => request.get('dashboard/admin/settings/faqs', { params }),
  create: (payload, file) =>
    file
      ? request.post(
          'dashboard/admin/settings/faqs',
          toFormData(payload, file),
          {},
        )
      : request.post('dashboard/admin/settings/faqs', payload),
  update: (id, payload, file) =>
    file
      ? request.put(
          `dashboard/admin/settings/faqs/${id}`,
          toFormData(payload, file),
          {},
        )
      : request.put(`dashboard/admin/settings/faqs/${id}`, payload, {}),
  delete: (id) => request.delete(`dashboard/admin/settings/faqs/${id}`),
};

export default settingsFaqsService;

